export interface ProductListStateModel {
	pagination?: number;
	filter?: string;
	origin?: any;
	active?: any;
}

export class ProductStateModel {
	productList?: ProductListStateModel;
}
